import React from "react"
import { Container } from "react-bootstrap"
import BannerImage from "../../images/niradhi/banner.png"

const Banner = () => {
  return (
    <div className="py-5 additional-top-padding">
      <Container>
        <img src={BannerImage} className="w-100" alt="niradhi banner" />
      </Container>
    </div>
  )
}

export default Banner
